export default {"src":"/_next/static/media/0x0b2c639c533813f4aa9d7837caf62653d097ff85.6f7cbaef.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};